export enum EmailVerificationType {
  SignUp = "SignUp",
  PasswordReset = "PasswordReset",
}
